module.exports = __webpack_public_path__ + "img/signNull.8294e92e.png";